import { render, staticRenderFns } from "./TDSuppliers.vue?vue&type=template&id=1d49ca38"
import script from "./TDSuppliers.vue?vue&type=script&lang=js"
export * from "./TDSuppliers.vue?vue&type=script&lang=js"
import style0 from "./TDSuppliers.vue?vue&type=style&index=0&id=1d49ca38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports